// Dağıtım ortamı — derleme sabiti `REACT_APP_ENVIRONMENT` (frontend/Dockerfile ARG'si).
//
// "sandbox" = test.flexbee.app (Public API müşterisinin test ortamı). Bu kipte:
//  - giriş sayfası parola formu yerine "canlı panelden girin" açıklamasını gösterir
//    (sunucu da parola uçlarını 403 sandbox.passwordLoginDisabled ile kapatır);
//  - uygulama kabuğunda kalıcı "Test Ortamı" şeridi görünür;
//  - Entegrasyonlar'daki "Test Ortamı" sekmesi gizlenir (sandbox içinden sandbox'a gidilmez).
//
// FONKSİYON, sabit değil: testler process.env'i çalışma anında değiştirebilsin. Üretim derlemesinde
// CRA `process.env.REACT_APP_*` ifadesini derleme anında sabite çevirir; davranış aynıdır.
export const isSandboxEnvironment = () => process.env.REACT_APP_ENVIRONMENT === 'sandbox';

// Canlı panel — sandbox'a giriş belgesi YALNIZ burada üretilir.
export const LIVE_PANEL_URL = 'https://panel.flexbee.app';

// Canlı paneldeki Entegrasyonlar > Test Ortamı sekmesi (sandbox'ın giriş ve hata ekranları buraya döner).
export const LIVE_SANDBOX_TAB_URL = `${LIVE_PANEL_URL}/integrations?tab=sandbox`;

// Sandbox API belgesi — sunucu `docsUrl` döndürmezse kullanılır.
export const SANDBOX_DOCS_URL = 'https://docs.flexbee.app/#tag/Sandbox';

// API kökü — derleme sabiti (frontend/Dockerfile ARG REACT_APP_API_URL). api.js ile AYNI geri düşüş.
export const apiBaseUrl = () => process.env.REACT_APP_API_URL || 'http://localhost:5148';

// Kurumsal girişin başlangıcı TAM SAYFA yönlendirmedir (IdP'ye gider, geri döner) — axios değil, tarayıcı adresi.
export const ssoStartUrl = ({ email, connection, challenge }) => {
  const params = new URLSearchParams({ client: 'web', challenge });
  if (email) params.set('email', email);
  if (connection) params.set('connection', connection);
  return `${apiBaseUrl()}/v1/auth/sso/start?${params.toString()}`;
};
